<div class="flex items-center md:items-start sm:justify-center md:justify-start flex-auto">
    <div
        class="flex md:items-center md:justify-center w-full md:h-full py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">
        <div class="w-full flex flex-col justify-center items-center max-w-80 sm:w-80 mx-auto sm:mx-0">
            <!-- Logo -->
            <div class="w-full text-center">
                <img src="assets/images/logo/logo.svg" alt="logo" loading="lazy">
            </div>

            <!-- Title -->
            <div class="flex justify-center mt-8 text-2xl font-extrabold tracking-tight leading-tight">Email
                Confirmation</div>
            <div class="mt-4 flex justify-center">
                {{text}}
            </div>
            <div class="font-medium text-lg" *ngIf="success">
                Proceed to <a class="ml-1 text-primary-500 hover:underline font-bold" [routerLink]="['/sign-in']">Login
                </a>
            </div>
            <div class="font-medium text-2xl text-warn py-2 text-center" *ngIf="!success">
                <p>Failed to verify email / Or email was already verified.</p>
                <span class="text-black flex justify-center mt-4">
                    Go to <a class="ml-2 text-primary-500 hover:underline font-bold" [routerLink]="['/sign-in']">Login
                    </a>
                </span>
                 
            </div>
        </div>
    </div>
</div>